module.exports = __webpack_public_path__ + "img/isaac.132b9f8b.svg";